export type StockStorageType =
  | 'ambient'
  | 'chilled'
  | 'frozen'
  | 'unknown storage type';
